import type { ReactNode, ComponentPropsWithoutRef } from 'react';
import type { AxonEvent } from '@reflex/shared';
import { Separator } from '@reflex/ui/components/ui/separator';
import { cn } from '@reflex/ui/lib/utils';
import { EventDetailTooltip } from './EventMeta';
export function DividerBubble({
  event,
  children,
  className,
  ...rest
}: Omit<ComponentPropsWithoutRef<'div'>, 'children'> & {
  event?: AxonEvent;
  children?: ReactNode;
}) {
  return (
    <div className={cn('flex items-center justify-center gap-2 py-3', className)} {...rest}>
      <Separator className="flex-1" />
      {children}
      {event ? <EventDetailTooltip event={event} /> : null}
      <Separator className="flex-1" />
    </div>
  );
}
